// Table row helpers

import { formatOcrDate } from "./normalizers";

export const mapSubjectsToTableRows = (subjectRows) =>
  subjectRows.map((row) => [
    row.subject || row.name || "",
    row.marks_obtained ?? row.obtained ?? "",
    row.total_marks ?? row.total ?? "",
  ]);

export const subjectsFromTableRows = (rows) =>
  rows
    .map((row) => ({
      subject: row[0] || "",
      marks_obtained: row[1] || "",
      total_marks: row[2] || "",
    }))
    .filter((row) => row.subject || row.marks_obtained || row.total_marks);

export const mapWorkTimelineToTableRows = (workTimeline) =>
  workTimeline.map((row) => [
    row.company || "",
    row.position || "",
    formatOcrDate(row.start_date) || row.start_date || "",
    formatOcrDate(row.end_date) || row.end_date || "",
  ]);

export const workTimelineFromTableRows = (rows) =>
  rows
    .map((row) => ({
      company: row[0] || "",
      position: row[1] || "",
      start_date: row[2] || "",
      end_date: row[3] || "",
    }))
    .filter((row) => row.company || row.position);

export const resolveSubjectRows = (data) => {
  if (Array.isArray(data.subjects)) return data.subjects;
  if (Array.isArray(data.subject_wise_marks)) return data.subject_wise_marks;
  return null;
};
